export default __webpack_public_path__ + "static/media/button-right-no-border.b5338fed.svg";